import { api } from '@/api';

export interface UserApiModel {
  uuid: string;
  name: string;
  email: string;
  phone_number: string;
  is_active: boolean;
  updated_at: string;
}

export interface UsersListPayload {
  count: number;
  next: string | null;
  previous: string | null;
  results: UserApiModel[];
}

export interface CreateUserPayload {
  name: string;
  email: string;
  phone_number: string;
  password: string;
  is_active?: boolean;
}

export interface UpdateUserPayload {
  name?: string;
  email?: string;
  phone_number?: string;
  is_active?: boolean;
}

export const usersService = {
  async list(page: number = 1, pageSize: number = 15, name?: string, email?: string): Promise<UsersListPayload> {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
    });
    
    if (name && name.trim()) {
      params.append('name', name.trim());
    }
    
    if (email && email.trim()) {
      params.append('email', email.trim());
    }
    
    const response = await api.get<UsersListPayload>(`/backoffice/api/v1/users/?${params.toString()}`);
    return response as unknown as UsersListPayload;
  },
  async create(payload: CreateUserPayload): Promise<unknown> {
    return api.post<unknown>('/backoffice/api/v1/users/', payload);
  },
  async update(uuid: string, payload: UpdateUserPayload): Promise<unknown> {
    return api.patch<unknown>(`/backoffice/api/v1/users/${uuid}/`, payload);
  },
  async toggleActive(uuid: string, is_active: boolean): Promise<unknown> {
    return api.put<unknown>(`/backoffice/api/v1/users/${uuid}/`, { is_active: is_active });
  },
  async delete(uuid: string): Promise<unknown> {
    return api.delete<unknown>(`/backoffice/api/v1/users/${uuid}/`);
  },
};

export default usersService;
